import ImportEmployeeErrorModal from '@/components/modal/ImportEmployeeErrorModal'
import ImportEmployeeResultModal from '@/components/modal/ImportEmployeeResultModal'
import UploadFile from '@/components/UploadFile'

export default {
    components: {
        UploadFile,
        ImportEmployeeResultModal,
        ImportEmployeeErrorModal
    },

    data () {
        return {
            isDrag: false,
            file: null,
            isUploading: false,
            uploadFiles: [],
            importResult: {
                title: '',
                content: null
            },
            importError: {}
        }
    },

    computed: {
        classDragged () {
            if (this.isDrag) {
                return 'big-image'
            }
            return ''
        },

        onDrag () {
            if (this.isDrag) {
                return 'on-drag'
            }
            return ''
        }
    },

    methods: {
        dragOver () {
            this.isDrag = true
        },

        dragLeave () {
            this.isDrag = false
        },

        selectFile () {
            this.$refs.browseFile.click()
        },

        async onSelectFile (event) {
            const fileList = event.target.files

            if (this.isUploading === true) {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.employeeImportList.uploadOneFile'))
            }

            if (fileList[0]) {
                this.file = fileList[0]
                await this.uploadFile()
            }
        }
    }
}
